'use client';

import { useEffect, useState } from 'react';
import { thresholdFromTiers, formatThreshold } from '@/lib/free-shipping';
import { useLocale } from '@/hooks/useLocale';

const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3001/api';

let cached: number | null = null;

/**
 * Klientsidan: fri frakt-tröskeln formaterad, t.ex. "5 000 kr".
 * Cachas i modulscope så att varje ny montering inte hämtar igen.
 * Samma mönster som useProductCount.
 */
export function useFreeShippingThreshold(): string {
  const { locale } = useLocale();
  const [amount, setAmount] = useState<number>(cached ?? 5000);

  useEffect(() => {
    if (cached !== null) { setAmount(cached); return; }
    fetch(`${API_URL}/checkout/shipping`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        const t = thresholdFromTiers(d?.tiers);
        cached = t;
        setAmount(t);
      })
      .catch(() => {});
  }, []);

  return formatThreshold(amount, locale);
}

/**
 * Fri frakt-tröskeln som TAL, för beräkningar (progressbar, "X kr kvar").
 * Samma källa och samma cache som useFreeShippingThreshold, bara oformaterad.
 */
export function useFreeShippingAmount(): number {
  const [amount, setAmount] = useState<number>(cached ?? 5000);
  useEffect(() => {
    if (cached !== null) { setAmount(cached); return; }
    fetch(`${API_URL}/checkout/shipping`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { const v = thresholdFromTiers(d?.tiers); cached = v; setAmount(v); })
      .catch(() => {});
  }, []);
  return amount;
}
